 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"admin":"admin","aliBey":"aliBey","dashboard":"dashboard","workouts":"workouts","habit~nutrition":"habit~nutrition","nutrition":"nutrition","HomeNew.vue":"HomeNew.vue","user":"user","einmalig":"einmalig","habit":"habit","contract-v2":"contract-v2","shop":"shop","chat":"chat","social":"social","deviceManagement":"deviceManagement","event":"event","gf":"gf","friends":"friends","live-quiz":"live-quiz","live-quiz-host":"live-quiz-host","live-quiz-manage":"live-quiz-manage","payment":"payment","redirection":"redirection","trainerpoint-live":"trainerpoint-live"}[chunkId]||chunkId) + "." + {"chunk-04a70578":"7a4c6ee1","chunk-0637e8e6":"14cf4f78","chunk-8aedfcda":"92adb07e","chunk-0c0834e4":"d2f531e0","admin":"2635b611","aliBey":"2b98c1f7","chunk-1d2e3766":"36709c3d","chunk-35408208":"5f5d587b","chunk-41aa1ba0":"6b9744b0","chunk-1fb712dd":"67eeffca","chunk-715ed311":"42e082ce","dashboard":"9ce801d8","workouts":"47607736","chunk-6f564565":"608cb199","habit~nutrition":"f177cb18","nutrition":"87358be9","chunk-2d216f56":"5478984d","chunk-5d752f00":"ab85eeee","chunk-90fff2c4":"b794904d","chunk-b1de7e32":"8928306a","chunk-f03f81fa":"9ecb0d9a","HomeNew.vue":"9c6ee18d","chunk-2fa6c09f":"00efb6d9","chunk-3ef0055f":"5745d6a8","chunk-69c05e07":"f1dac72e","user":"19f51582","chunk-b067410a":"3dc4a508","chunk-ef2249dc":"92d13441","chunk-fd7ca6de":"86c1c047","chunk-51ceab26":"08881958","einmalig":"b924c90d","habit":"83096d28","chunk-1569fc9b":"1bda2b66","chunk-1a7d3fee":"34b119e6","chunk-1c81a122":"4b361acc","chunk-059f5466":"15c1fd70","chunk-1447a746":"d36378f0","chunk-1a812538":"2850cafe","chunk-38352eb4":"5117c807","chunk-4354930d":"9f4ffe78","chunk-4cf70380":"d845cad2","chunk-505b5877":"c1af32f0","chunk-94e14e52":"e685ba57","chunk-9826f532":"8f0c1934","chunk-d6e7dbea":"1d36eba9","chunk-d8c05fc2":"7deee348","chunk-617025bb":"dd7684b1","chunk-6a994f80":"f5e38f05","chunk-27a66c4e":"b6b232ea","chunk-2c2a0b52":"430fb1ac","contract-v2":"f3aed8f3","chunk-1e47ee7b":"80515667","chunk-1e90651e":"9cf00be5","chunk-28d824b1":"9f0f9438","chunk-2c17ccc7":"f3e36bbc","chunk-2cba09c1":"20d3d45c","chunk-2d0abe58":"cb79b1c2","chunk-2d0ae56b":"da7c86ae","chunk-2d0dda10":"fc094788","chunk-2d0ac1cd":"5f1bffde","shop":"81790f9e","chunk-329894d6":"427d4ecf","chunk-32d00dc6":"102f7ee8","chunk-35f42bac":"b9cea346","chunk-37feaa88":"b6bcff6f","chunk-3cc4f14e":"3a89c0df","chunk-3e175f3a":"0d192ad2","chunk-40f278fa":"398401e9","chat":"790a8dfb","chunk-6e83591c":"22ec3898","social":"feee94f4","deviceManagement":"0c7678dc","event":"70b5c709","chunk-4406f81f":"6bae5bb9","chunk-44e7c469":"e416e1db","chunk-4573c130":"bb1036ee","chunk-59b64568":"577c2f1c","chunk-5dff41d6":"a262f87b","chunk-613e6a72":"1fb3c558","chunk-294c0f45":"b43eb70e","chunk-70f221fc":"2e146b15","chunk-726839ae":"ebddc9fe","chunk-729b2e94":"7270104d","chunk-752eca3c":"c0bb10d6","chunk-77b5d08c":"d773c817","chunk-8015e132":"72190d25","chunk-90d705c6":"5c4daa56","chunk-d4d3e9ce":"525c99c9","chunk-d50be17a":"2611d337","chunk-13ef3e92":"da191eb2","chunk-7a562389":"4369fa65","chunk-999aab12":"55fe30da","chunk-b8dd6a52":"9307d439","chunk-ddb595f4":"dee5428a","chunk-b42459f0":"2987b719","gf":"dea81afb","friends":"c184791e","live-quiz":"3ad67d99","live-quiz-host":"47737ef3","live-quiz-manage":"2eb5ba0c","payment":"09903989","redirection":"3acbed28","chunk-2d209639":"94c15c44","chunk-2d216214":"1cff4ebd","chunk-2d216257":"58872a85","chunk-ee1fea50":"a4aafb0a","chunk-2d0c13c4":"7813a997","trainerpoint-live":"68e70a16","chunk-816d4dc0":"312f9ed4"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-04a70578":1,"chunk-0637e8e6":1,"chunk-8aedfcda":1,"chunk-0c0834e4":1,"admin":1,"aliBey":1,"chunk-1d2e3766":1,"chunk-35408208":1,"chunk-1fb712dd":1,"chunk-715ed311":1,"dashboard":1,"workouts":1,"chunk-6f564565":1,"habit~nutrition":1,"nutrition":1,"chunk-5d752f00":1,"chunk-90fff2c4":1,"chunk-b1de7e32":1,"chunk-f03f81fa":1,"HomeNew.vue":1,"chunk-2fa6c09f":1,"chunk-3ef0055f":1,"chunk-69c05e07":1,"user":1,"chunk-b067410a":1,"chunk-ef2249dc":1,"chunk-fd7ca6de":1,"chunk-51ceab26":1,"einmalig":1,"habit":1,"chunk-1569fc9b":1,"chunk-1a7d3fee":1,"chunk-1c81a122":1,"chunk-059f5466":1,"chunk-1447a746":1,"chunk-1a812538":1,"chunk-38352eb4":1,"chunk-4354930d":1,"chunk-4cf70380":1,"chunk-505b5877":1,"chunk-94e14e52":1,"chunk-9826f532":1,"chunk-d8c05fc2":1,"chunk-617025bb":1,"chunk-6a994f80":1,"chunk-27a66c4e":1,"chunk-2c2a0b52":1,"contract-v2":1,"chunk-1e47ee7b":1,"chunk-1e90651e":1,"chunk-28d824b1":1,"chunk-2c17ccc7":1,"chunk-2cba09c1":1,"shop":1,"chunk-329894d6":1,"chunk-32d00dc6":1,"chunk-35f42bac":1,"chunk-37feaa88":1,"chunk-3cc4f14e":1,"chunk-3e175f3a":1,"chunk-40f278fa":1,"chat":1,"social":1,"deviceManagement":1,"event":1,"chunk-4406f81f":1,"chunk-44e7c469":1,"chunk-4573c130":1,"chunk-59b64568":1,"chunk-5dff41d6":1,"chunk-613e6a72":1,"chunk-294c0f45":1,"chunk-70f221fc":1,"chunk-726839ae":1,"chunk-729b2e94":1,"chunk-752eca3c":1,"chunk-77b5d08c":1,"chunk-8015e132":1,"chunk-90d705c6":1,"chunk-d4d3e9ce":1,"chunk-d50be17a":1,"chunk-13ef3e92":1,"chunk-7a562389":1,"chunk-999aab12":1,"chunk-b8dd6a52":1,"chunk-ddb595f4":1,"chunk-b42459f0":1,"gf":1,"friends":1,"live-quiz":1,"live-quiz-host":1,"live-quiz-manage":1,"trainerpoint-live":1,"chunk-816d4dc0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"admin":"admin","aliBey":"aliBey","dashboard":"dashboard","workouts":"workouts","habit~nutrition":"habit~nutrition","nutrition":"nutrition","HomeNew.vue":"HomeNew.vue","user":"user","einmalig":"einmalig","habit":"habit","contract-v2":"contract-v2","shop":"shop","chat":"chat","social":"social","deviceManagement":"deviceManagement","event":"event","gf":"gf","friends":"friends","live-quiz":"live-quiz","live-quiz-host":"live-quiz-host","live-quiz-manage":"live-quiz-manage","payment":"payment","redirection":"redirection","trainerpoint-live":"trainerpoint-live"}[chunkId]||chunkId) + "." + {"chunk-04a70578":"d888e6e3","chunk-0637e8e6":"7e857e5e","chunk-8aedfcda":"4eb0deb2","chunk-0c0834e4":"ed310506","admin":"4fd301a5","aliBey":"d5f8cca3","chunk-1d2e3766":"5ee2c0e1","chunk-35408208":"65727138","chunk-41aa1ba0":"31d6cfe0","chunk-1fb712dd":"66a1c861","chunk-715ed311":"6f137c18","dashboard":"0f7fc56a","workouts":"966c55ce","chunk-6f564565":"50798865","habit~nutrition":"551557c5","nutrition":"3f18c82e","chunk-2d216f56":"31d6cfe0","chunk-5d752f00":"26db51fb","chunk-90fff2c4":"d9fc8c5f","chunk-b1de7e32":"fca5342d","chunk-f03f81fa":"350a1df7","HomeNew.vue":"b0198d2b","chunk-2fa6c09f":"63f80147","chunk-3ef0055f":"ed0f3c30","chunk-69c05e07":"b13bc959","user":"f0af284e","chunk-b067410a":"b4b6f499","chunk-ef2249dc":"38cdad1c","chunk-fd7ca6de":"42016920","chunk-51ceab26":"9c761e43","einmalig":"cc9b3599","habit":"346ce143","chunk-1569fc9b":"14952c85","chunk-1a7d3fee":"1eeb5770","chunk-1c81a122":"f543d584","chunk-059f5466":"aab52051","chunk-1447a746":"c9fe281c","chunk-1a812538":"70f60110","chunk-38352eb4":"10395e6d","chunk-4354930d":"c740b4af","chunk-4cf70380":"d4a8c6a9","chunk-505b5877":"b0d8115f","chunk-94e14e52":"2a59fb3e","chunk-9826f532":"1e86cea9","chunk-d6e7dbea":"31d6cfe0","chunk-d8c05fc2":"4be0704d","chunk-617025bb":"39f9a3a8","chunk-6a994f80":"f5a78ea6","chunk-27a66c4e":"c4ddac59","chunk-2c2a0b52":"f4811b68","contract-v2":"ff349b99","chunk-1e47ee7b":"0850be84","chunk-1e90651e":"f95702ee","chunk-28d824b1":"211ed81c","chunk-2c17ccc7":"6670cb88","chunk-2cba09c1":"9b9066fd","chunk-2d0abe58":"31d6cfe0","chunk-2d0ae56b":"31d6cfe0","chunk-2d0dda10":"31d6cfe0","chunk-2d0ac1cd":"31d6cfe0","shop":"b224513d","chunk-329894d6":"596227c3","chunk-32d00dc6":"e345f5a8","chunk-35f42bac":"144faf14","chunk-37feaa88":"8111135b","chunk-3cc4f14e":"c7a4d223","chunk-3e175f3a":"4e463851","chunk-40f278fa":"9e01e709","chat":"9562146f","chunk-6e83591c":"31d6cfe0","social":"d92bd277","deviceManagement":"23584837","event":"d8b22b17","chunk-4406f81f":"f2608e60","chunk-44e7c469":"23b3b31f","chunk-4573c130":"7b475960","chunk-59b64568":"5162a1fe","chunk-5dff41d6":"0e3c4884","chunk-613e6a72":"3fa4f906","chunk-294c0f45":"94406a52","chunk-70f221fc":"9d6fbaee","chunk-726839ae":"3fdd1937","chunk-729b2e94":"9e24781c","chunk-752eca3c":"d8623ff2","chunk-77b5d08c":"7d12f124","chunk-8015e132":"c66fd981","chunk-90d705c6":"513e63dd","chunk-d4d3e9ce":"f4cd17ba","chunk-d50be17a":"5c500477","chunk-13ef3e92":"0dcbb4c2","chunk-7a562389":"97875ae7","chunk-999aab12":"1621a854","chunk-b8dd6a52":"eb5b1670","chunk-ddb595f4":"2837fba7","chunk-b42459f0":"902a8fc4","gf":"41cebc21","friends":"2d95a385","live-quiz":"eca3295c","live-quiz-host":"90fa3a4b","live-quiz-manage":"947660bf","payment":"31d6cfe0","redirection":"31d6cfe0","chunk-2d209639":"31d6cfe0","chunk-2d216214":"31d6cfe0","chunk-2d216257":"31d6cfe0","chunk-ee1fea50":"31d6cfe0","chunk-2d0c13c4":"31d6cfe0","trainerpoint-live":"1fb51549","chunk-816d4dc0":"022d1cd6"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
